import React from 'react'
import PropTypes from 'prop-types'

import { Form, Page, Text, Button } from '@fielded/shared-ui'
import { Arrow } from '@fielded/shared-ui/src/icons'

import EntryViewWrapper from '../common/EntryViewWrapper'

const ChangePassword = ({
  config,
  onSubmit,
  onBack,
  inProcess,
  error
}) => {
  return (
    <EntryViewWrapper config={config}>
      <Page.Panel.Section>
        <div className='login__panel-title'>
          Choose a new password
        </div>
      </Page.Panel.Section>

      {error && (
        <Page.Panel.Message type='danger' cta={false}>
          {error}
        </Page.Panel.Message>
      )}

      <Page.Panel.Section>
        <Text>
          Type your new password below.
        </Text>
      </Page.Panel.Section>

      <Page.Panel.Section>
        <Form
          onSubmit={onSubmit}
          component='form'
        >
          <Form.Row>
            <Form.Field
              fieldName='password'
              labelText='Enter your new password'
            >
              <Form.Field.Text
                autoFocus
                maxLength={64}
                type='password'
                required='Please provide a password'
                disabled={inProcess}
                autoCapitalize='off'
              />
              <Form.Field.ValidationErrors />
            </Form.Field>
          </Form.Row>

          <Form.Row>
            <Form.Field
              fieldName='confirmPassword'
              labelText='Re-type password'
            >
              <Form.Field.Text
                maxLength={64}
                type='password'
                required='Please confirm your password'
                disabled={inProcess}
                autoCapitalize='off'
              />
              <Form.Field.ValidationErrors />
            </Form.Field>
          </Form.Row>

          <Form.Actions layout='left'>
            <Form.Button
              size='regular'
              disabled={inProcess}
              loading={inProcess}
            >
              Reset password
            </Form.Button>
          </Form.Actions>

          <Form.Actions layout='left'>
            <Button
              fill='none'
              size='regular'
              icon={<Arrow direction='left' />}
              iconSide='left'
              colorVariant='brand'
              onClick={onBack}
            >
              go back
            </Button>
          </Form.Actions>
        </Form>
      </Page.Panel.Section>
    </EntryViewWrapper>
  )
}

ChangePassword.propTypes = {
  config: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  inProcess: PropTypes.bool,
  error: PropTypes.string
}

ChangePassword.defaultProps = {
  inProcess: false,
  error: null
}

export default ChangePassword
